import React, { useState, useEffect } from 'react';
import { IOption } from '../Select';
import { optionType } from '../SelectMenu';

import { ReactComponent as CloseIcon } from './imgs/close.svg';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

interface IDrawer {
    options: IOption[],
    onChange: (option: IOption) => any,
    curId?: number | string,
    extraClass?: string,
    optionType?: optionType,
    titles?: string[],
    showDrawer?: boolean
}

interface IOptionStatck {
    parent: null | IOption,
    options: IOption[],
}

const Drawer: React.FC<IDrawer> = ({ options, onChange, curId, extraClass, titles = [], optionType, showDrawer }) => {
    const [optionStack, setOptionStack] = useState<IOptionStatck[]>([{ parent: null, options}]);
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        if (optionStack[optionStack.length - 1]?.options?.length === 0 && options?.length > 0) {
            setOptionStack([{ parent: null, options}])
        }
    }, [options, optionStack])

    const handleOptionClick = (option: IOption) => {
        if (option.options) {
            setOptionStack([...optionStack, {parent: option, options: option.options}]);
        } else if (optionStack.length > 1) {
            // 目前兼容2层
            onChange({
                id: option?.id,
                name: optionStack[optionStack.length - 1]?.parent?.name + '/' + option?.name
            })
        } else {
            onChange({
                id: option?.id,
                name: option?.name
            })
        }
    }
    const handleClose = () => {
        optionStack.pop();
        setOptionStack([...optionStack]);
    }

    useEffect(() => {
        if (showDrawer !== undefined && showDrawer !== null) {
            setShow(showDrawer);
            if (!showDrawer && optionStack.length > 1) {
                // 隐藏时，返回第一层
                setOptionStack([optionStack[0]]);
            }
        } else {
            setShow(true);
        }
    }, [showDrawer, optionStack]);
    
    return (
        <div className="select-drawer-menu-wrapper">
            <div className={`select-drawer-menu ${show ? 'show' : ''}`}>
                {titles.length ? <div className="title">
                    {/* <CloseIcon onClick={() => handleClose()} className="return-icon" /> */}
                    <span> {titles[optionStack.length - 1]} </span>
                </div> : null}
                {optionStack[optionStack.length - 1]?.options?.map(option => (
                    <div className="item" key={option.id + option.name} onClick={(e) => {
                        option.options && e.stopPropagation();
                        handleOptionClick(option)
                    }}>
                        { optionType === 'phone' ? <span className="phone-code"> {option.id} </span> : null }
                        <span> {option.name}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Drawer;
